import axios from 'axios';

import { interceptorAddToken, queryString } from './Api';
import config from '../config';
import StorageHelper from '../helpers/StorageHelper';

const ApiUsuario = axios.create({
  baseURL: config.urlApiUsuario,
  paramsSerializer: queryString,
});

ApiUsuario.interceptors.request.use((config) => {
  config = interceptorAddToken(config);

  const id_entidade = StorageHelper.getUser()?.id_entidade;

  if (id_entidade) {
    config.headers.id_entidade = id_entidade;
  }

  return config;
});

export default ApiUsuario;
